/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TakeHomeArtifactSummary } from './TakeHomeArtifactSummary';
import {
    TakeHomeArtifactSummaryFromJSON,
    TakeHomeArtifactSummaryFromJSONTyped,
    TakeHomeArtifactSummaryToJSON,
    TakeHomeArtifactSummaryToJSONTyped,
} from './TakeHomeArtifactSummary';
import type { TakeHomeViewVisit } from './TakeHomeViewVisit';
import {
    TakeHomeViewVisitFromJSON,
    TakeHomeViewVisitFromJSONTyped,
    TakeHomeViewVisitToJSON,
    TakeHomeViewVisitToJSONTyped,
} from './TakeHomeViewVisit';

/**
 * 
 * @export
 * @interface TakeHomeView
 */
export interface TakeHomeView {
    /**
     * 
     */
    visit: TakeHomeViewVisit;
    /**
     * **Summaries only.** The panel this renders is a list of titles — the Figma shows four
     * items — and the payloads behind them are replayable game state, so shipping them all
     * before the page paints is the wrong trade on a phone, over a home connection, a year
     * later. Fetch one from `GET /learn/me/{token}/artifacts/{artifactId}` when the reader
     * taps it to replay; that route exists for exactly this and was previously redundant,
     * because this list already returned everything it returns.
     * 
     */
    artifacts: Array<TakeHomeArtifactSummary>;
}

/**
 * Check if a given object implements the TakeHomeView interface.
 */
export function instanceOfTakeHomeView(value: object): value is TakeHomeView {
    if (!('visit' in value) || value['visit'] === undefined) return false;
    if (!('artifacts' in value) || value['artifacts'] === undefined) return false;
    return true;
}

export function TakeHomeViewFromJSON(json: any): TakeHomeView {
    return TakeHomeViewFromJSONTyped(json, false);
}

export function TakeHomeViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): TakeHomeView {
    if (json == null) {
        return json;
    }
    return {
        
        'visit': TakeHomeViewVisitFromJSON(json['visit']),
        'artifacts': ((json['artifacts'] as Array<any>).map(TakeHomeArtifactSummaryFromJSON)),
    };
}

export function TakeHomeViewToJSON(json: any): TakeHomeView {
    return TakeHomeViewToJSONTyped(json, false);
}

export function TakeHomeViewToJSONTyped(value?: TakeHomeView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visit': TakeHomeViewVisitToJSON(value['visit']),
        'artifacts': ((value['artifacts'] as Array<any>).map(TakeHomeArtifactSummaryToJSON)),
    };
}

